<template>
  <v-dialog max-width="500px" v-model="inDialog" @click:outside="onClickOutside" persistent>
    <v-card>
      <v-form ref="viewPresentForm">
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
                $t(formCreateName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-layout wrap>
<!--            <v-flex xs12>-->
<!--              <v-text-field-->
<!--                  type="text"-->
<!--                  :label="$t('Mã lớp')"-->
<!--                  v-model.trim="item.classCode"-->
<!--                  name="classCode"-->
<!--                  v-validate="'required'"-->
<!--                  maxLength="250"-->
<!--                  :error-messages="errors.first('classCode')"-->
<!--                  :data-vv-as="$t('Mã lớp')"-->
<!--              ></v-text-field>-->
<!--            </v-flex>-->
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Tên lớp')"
                  v-model.trim="item.className"
                  name="className"
                  v-validate="'required'"
                  maxLength="250"
                  :error-messages="errors.first('className')"
                  :data-vv-as="$t('Tên lớp')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="programs"
                  :label="$t('Khung chương trình')"
                  v-model="item.programId"
                  name="programId"
                  item-value="programId"
                  item-text="programName"
                  v-validate="'required'"
                  :data-vv-as="$t('Level')"
                  :error-messages="errors.first('programId')"
                  :disabled="item.pondId ? true : false"
                  v-on:change="levelChange(item.programId)"
              />
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="accountZalos"
                  :label="$t('Tài khoản zalo quản lý lớp')"
                  v-model="item.accountZaloId"
                  name="accountZaloId"
                  item-value="accountZaloId"
                  item-text="accountZaloName"
                  :data-vv-as="$t('Level')"
                  :error-messages="errors.first('accountZaloId')"
                  :disabled="item.pondId ? true : false"
                  v-on:change="levelChange(item.accountZaloId)"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Link lớp học')"
                  v-model.trim="item.classLink"
                  name="classLink"
                  maxLength="250"
                  :error-messages="errors.first('classLink')"
                  :data-vv-as="$t('Link lớp học')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <i-datepicker
                  :label="$t('Ngày khai giảng')"
                  v-model="item.startDate"
                  v-validate="'required'"
                  :defaultValue="item.startDate ? true : false"
                  :error-messages="errors.first('startDate')"
                  @clearText="clearDropDate"
                  clearable
              />
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="areaStatus"
                  :label="$t('Trạng thái')"
                  v-model="item.isActive"
                  name="isActive"
                  item-value="value"
                  item-text="text"
                  :data-vv-as="$t('Trạng thái')"
                  :error-messages="errors.first('isActive')"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
      <div style="text-align: right">
        <v-btn color="primary" @click="onSave">
          <v-icon dark left>save</v-icon>
          {{ $t("lang.common.save") }}
        </v-btn>
        <v-btn color="error" @click="onCancel">
          <v-icon dark left>cancel</v-icon>
          {{ $t("lang.common.cancel") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {message} from "../../../services";
import axios from "axios";
import {areaContants, cateContants} from "@/constants";
import moment from "moment/moment";

export default {
  name: "material-type-group-create",
  components: {message, axios},
  props: {
    propsItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    cDialog: {
      type: Boolean,
      default: false,
    },
    formCreateName: {
      type: String,
      default: '',
    },
    units: {
      type: Array,
      default: [],
    },

    programs: {
      type: Array,
      default: [],
    },
    accountZalos: {
      type: Array,
      default: [],
    },
    clearable: {
      type: Boolean,
      default: false
    },
  },
  data: () => {
    return {
      areaStatus: cateContants.classIsActive,
      item: {
        classCode: "",
        className: "",
        programID: "",
        accountZaloId: "",
        startDate: "",
        classLink:"",
        isActive: 1,
      },
      inDialog: false,
    };
  },
  watch: {
    propsItem: {
      handler(value) {
        //console.log(value);
        if (value !== null) {
          this.item = {
            classId: value.classId,
            classCode: value.classCode
                ? value.classCode
                : "",
            className: value.className
                ? value.className
                : "",
            programId: value.programId
                ? value.programId
                : "",
            accountZaloId: value.accountZaloId
                ? value.accountZaloId
                : "",
            classLink: value.classLink
                ? value.classLink
                : "",
            startDate: value.startDate
                ? value.startDate
                : "",
            status: value.status ? value.status : 0,
            isActive: value.isActive ? value.isActive : 0,
          };
        } else {
          this.resetFrom();
        }
      },
      deep: true,
    },
    cDialog(value) {
      this.inDialog = value;
    },
    inDialog(value) {
      if (!value) {
        this.$emit("closeCreateDialog", "");
      }
    },
  },
  methods: {
    resetFrom: function () {
      this.item = {
        classCode: "",
        className: "",
        classLink:"",
        programID: "",
        accountZaloId: "",
        startDate: "",
        isActive: 1,
      };
    },
    checkMinDate(minDate = moment()) {
      if (minDate == '' || minDate == null) minDate = moment();
      let minDate_tmp = moment(String(minDate));
      let today = moment();
      // if (minDate_tmp <= today) {
      //     minDate = moment().format('YYYY-MM-DD');
      // } else {
      minDate = minDate_tmp.format('YYYY-MM-DD');
      // }
      return minDate;
    },
    clearDropDate() {
      this.item.startDate = '';
    },
    levelChange(levelId) {
      this.getNextCode();
    },
    getNextCode: function () {
      axios.post(
          process.env.VUE_APP_API_URL + "/babiLevel/listAllName", {status: 1}
      )
          .then((data) => {
            this.item = Object.assign({}, this.item, {"code": data})
          });
    },
    onCancel: function () {
      this.$emit("closeCreateDialog", "");
    },
    onSave: function () {
      // console.log(this.item);
      this.$validator.validate().then((valid) => {
        if (!valid) {
          message.error(this.$t("lang.common.validate_fail"));
          return;
        }
        axios
            .post(
                process.env.VUE_APP_API_URL +
                "/babiClass/save",
                this.item
            )
            .then(
                (data) => {
                  if (data.success) {
                    message.success(
                        this.$t("lang.common.save_success")
                    );
                    this.resetFrom();
                    this.onCancel();
                  } else {
                    let msg = data.description;
                    if (data.description === 'lang.category.duplicateCode') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    } else if (data.description === 'lang.category.duplicateName') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    }
                    message.error(this.$t(msg));
                  }
                },
                (error) => {
                  console.log(error);
                }
            );
      });
    },

  },
  created() {
    // Program
    axios.post(
        process.env.VUE_APP_API_URL + "/babiProgram/listAllName", {status: 1}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                this.programs = data;
              }
            }
        );


    // accountZalo
    axios.post(
        process.env.VUE_APP_API_URL + "/kidAccountZalo/listAllName", {status: 1}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                this.accountZalos = data;
              }
            }
        );
  },
};
</script>
